<template>
  <v-card :style="{'height': blockHeight + 'px'}">
    <v-card-title>
      <h1 class="headline">
        Параметры доступа
      </h1>
    </v-card-title>

    <v-card-actions class="px-3 py-0">
      <v-flex
        xs12
        sm8
        md6
      >
        <v-select
          v-model="selected"
          :items="roles"
          label="Роль пользователя"
          hide-details
          item-text="title"
          item-value="id"
          return-object
          menu-props="offsetY"
          outline
          height="44"
          clearable
          clear-icon="close"
          @click:clear="clear"
          @change="change"
        />
      </v-flex>
    </v-card-actions>

    <v-card-text>
      <v-layout>
        <v-flex
          v-for="(itemsSection, index) in itemsSections"
          :key="index"
        >
          <v-layout align-content-end>
            <v-flex xs11>
              <v-list
                subheader
                class="mx-2"
              >
                <v-subheader v-if="itemsSection.subItems">
                  {{ itemsSection.title }}
                </v-subheader>
                <div :style="{'height': blockHeight - 260 + 'px', 'overflow-y': 'auto'}">
                  <v-list-tile
                    v-for="item in itemsSection.subItems"
                    :key="item.title"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title style="height: auto; white-space: pre-line;">
                        {{ item.title }}
                      </v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-switch
                        v-model="permissions"
                        :disabled="!selected"
                        :value="item.route"
                      />
                    </v-list-tile-action>
                  </v-list-tile>
                </div>
              </v-list>
            </v-flex>
            <v-flex xs1>
              <v-divider vertical />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider class="mx-3" />

    <v-card-actions class="pa-3">
      <v-btn
        small
        color="primary"
        :disabled="!selected"
        @click="submit"
      >
        Сохранить
      </v-btn>
      <v-btn
        small
        :disabled="permissions.length === 0"
        @click="cancel"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { appMenu } from "../appMenu.js";
import * as usersPermissionsApi from "../backend/usersPermissionsApi.js";

export default {
  data() {
    return {
      selected: null,
      permissions: [],
      roles: [],
      templatePermissions: [],
    };
  },
  computed: {
    itemsSections() {
      const items = appMenu.filter((i) => {
        if (i.route === "users-permissions") {
          return;
        }
        return i.route;
      });
      const sections = appMenu.filter((i) => i.subItems);
      sections.splice(0, 0, { title: "Основные", subItems: items });
      return sections;
    },
    blockHeight() {
      return window.innerHeight - 41;
    },
  },
  created() {
    this.getRoles();
  },
  methods: {
    async getPermissions() {
      if (this.selected) {
        this.permissions = await usersPermissionsApi.getPermission(
          this.selected.id,
        );
      }
      this.templatePermissions = this.permissions;
    },
    change() {
      this.getPermissions();
    },
    async submit() {
      await usersPermissionsApi.createPermissions(
        this.selected.id,
        this.permissions,
      );
      this.showInfo("Изменения сохранены");
    },
    cancel() {
      this.permissions = this.templatePermissions;
    },
    clear() {
      this.selected = null;
      this.permissions = [];
      this.templatePermissions = [];
    },
    async getRoles() {
      const result = await usersPermissionsApi.getUserRoles();
      this.roles = result.map((i) => {
        return {
          id: i.Id,
          title: i.Title,
          isRemoved: i.IsRemoved,
        };
      });
    },
  },
};
</script>
